module.exports = __webpack_public_path__ + "img/dp02.3bc06d51.png";